// urlTool.中的addUrlParameter方法会重复添加，所以新增一个方法适用于 ?key=value&key=value 的情况
/*eslint-disable */
function setUrlParam(url, key, value) {
    url = url || location.href;

    let reg;
    if (!value && value !== 0) {
        // value为空，需要删除这对kv
        reg = new RegExp(`(&${key}=[^&]*)`, 'gmi');
        if (reg.test(url)) {
            // ?test1=9&q=面&test2=12    ?test1=9&test2=12&q=面
            url = url.replace(reg, '');
            return url;
        }

        reg = new RegExp(`([?]${key}=[^&]*[&]*)`, 'gmi');
        if (reg.test(url)) {
            // ?q=面&test1=9&test2=12
            url = url.replace(reg, '?');

            // 删除kv后可能最后一位是?号
            reg = new RegExp('([?]$)', 'gmi');
            if (reg.test(url)) {
                // ?q=面
                url = url.replace(reg, '');
            }
            return url;
        }

        return url;
    }
    reg = new RegExp(`([?&]${key})=[^&]*`, 'gmi');
    if (reg.test(url)) {
        url = url.replace(reg, `$1=${value}`); // $1代表括号中的部分
    } else {
        if (url.indexOf('?') === -1) {
            url += '?';
        } else {
            url += '&';
        }
        url += `${key}=${value}`;
    }
    // console.log('900990');
    // console.log(value);
    // console.log(url);
    return url;

    // // debugger
    // if (value || value === 0) {
    //     var reg = new RegExp('([?&]' + key + ')=[^&]*', 'gmi');
    //     if (reg.test(url)) {
    //         url = url.replace(reg, '$1=' + value); // $1代表括号中的部分
    //     } else {
    //         if (url.indexOf('?') === -1) {
    //             url += '?';
    //         }
    //         else {
    //             url += '&';
    //         }
    //         url += (key + '=' + value);
    //     }
    //     return url;
    // } else {
    //     // debugger
    //     let urlPath = url.split('?')[0];
    //     let args = url.split('?')[1].split('&');
    //     const argIndex = _.findIndex(args, item => {
    //         return item.indexOf(key) !== -1;
    //     });
    //     argIndex >= 0 && _.pullAt(args, argIndex);
    //     urlPath += args.length > 0 ? '?' + args.join('&') : args.join('&');
    //     return urlPath;
    // }
}
// 获取 tab名转数字类型
function getCurrentType(data) {
    console.log(data, 'data');

    switch (data) {
        case 'staffSensitiveWords':
            return 1;
        case 'staffSensitiveAction':
            return 2;
        case 'clientSensitiveWords':
            return 3;
        default:
            return '';
    }
}
// 数字类型转名字
function getCurrentName(data) {
    switch (data) {
        case 1:
            return 'staffSensitiveWords';
        case 2:
            return 'staffSensitiveAction';
        case 3:
            return 'clientSensitiveWords';
        default:
            return '';
    }
}
export default {
    setUrlParam,
    getCurrentType,
    getCurrentName
};
